import { useNavigate } from "react-router-dom";
import CardBasicComponent from "../../components/card/CardBasicComponent";
import { useRequest } from "../../hooks/useRequest";
import { HeadLine } from "../../layouts/headers/HeadLine";
import { getApiUrl } from '../../app-config';
import { useEffect, useState } from "react";

export const SpotsMain = () => {

    const navigate = useNavigate();
    const { data } = useRequest(getApiUrl('panel/PointsInterest?destinationId=1', '1.0'));
    const [spots, setSpots] = useState([]);

    useEffect(() => {
        if (data) setSpots(data);
    }, [data])

    const handleClickElement = (e: any) => {
        navigate('/near-spots/spot/' + e.id);
    }

    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Puntos Cercanos' backurl='/' />
            </div>
            <div className='w-full relative content-hi-sm'>
                <div className="title-head-hi">Destinos</div>


                <div className="text-center">
                    <CardBasicComponent items={spots} click={handleClickElement} />

                    <div className="flex items-center justify-center mt-4">

                        <span className="mr-2">Ver más</span>
                        <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.48621 7.79483C7.39797 7.79483 7.30857 7.76775 7.23178 7.71149C7.0399 7.57074 6.99835 7.30113 7.1391 7.10925L12.2213 0.176947C12.3623 -0.0149294 12.6314 -0.0569462 12.8237 0.0842769C13.0156 0.225033 13.0572 0.494641 12.9164 0.686518L7.83448 7.61859C7.74975 7.73367 7.61903 7.79483 7.48621 7.79483ZM6.50068 8.65454C6.3723 8.65454 6.24531 8.59758 6.16058 8.48834L0.091019 0.696322C-0.0553395 0.508647 -0.0214926 0.237872 0.165949 0.0915132C0.353857 -0.0546119 0.624866 -0.0209985 0.770758 0.166677L6.84009 7.95869C6.98644 8.1466 6.9526 8.41738 6.76515 8.5635C6.68672 8.62489 6.59335 8.65454 6.50068 8.65454Z" fill="black" />
                        </svg>

                    </div>
                </div>

                {/*   <div className="title-head-hi mt-4">Bares y restaurantes</div>

                <div>
                    <CardBasicComponent items={restaurantes} click={() => { }} />
                    <div className="flex items-center justify-center mt-4">

                        <span className="mr-2">Ver más</span>
                        <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.48621 7.79483C7.39797 7.79483 7.30857 7.76775 7.23178 7.71149C7.0399 7.57074 6.99835 7.30113 7.1391 7.10925L12.2213 0.176947C12.3623 -0.0149294 12.6314 -0.0569462 12.8237 0.0842769C13.0156 0.225033 13.0572 0.494641 12.9164 0.686518L7.83448 7.61859C7.74975 7.73367 7.61903 7.79483 7.48621 7.79483ZM6.50068 8.65454C6.3723 8.65454 6.24531 8.59758 6.16058 8.48834L0.091019 0.696322C-0.0553395 0.508647 -0.0214926 0.237872 0.165949 0.0915132C0.353857 -0.0546119 0.624866 -0.0209985 0.770758 0.166677L6.84009 7.95869C6.98644 8.1466 6.9526 8.41738 6.76515 8.5635C6.68672 8.62489 6.59335 8.65454 6.50068 8.65454Z" fill="black" />
                        </svg>

                    </div>
                </div> */}
            </div>
        </>
    );

};
